import { clsx } from 'clsx';
import '../common/theme.mjs';
import '../common/direction.mjs';
import '../common/propsValues/control.mjs';
import '../common/propsValues/breakpoint.mjs';
import { Size } from '../common/propsValues/size.mjs';
import '../common/propsValues/typography.mjs';
import '../common/propsValues/width.mjs';
import '../common/propsValues/type.mjs';
import '../common/propsValues/dateMode.mjs';
import '../common/propsValues/monthFormat.mjs';
import '../common/propsValues/position.mjs';
import '../common/propsValues/layouts.mjs';
import '../common/propsValues/status.mjs';
import { Sentiment } from '../common/propsValues/sentiment.mjs';
import '../common/propsValues/profileType.mjs';
import '../common/propsValues/variant.mjs';
import '../common/propsValues/scroll.mjs';
import '../common/propsValues/markdownNodeType.mjs';
import '../common/fileType.mjs';
import '@transferwise/icons';
import 'react';
import 'react-intl';
import '../common/closeButton/CloseButton.messages.mjs';
import { jsxs, jsx } from 'react/jsx-runtime';
import StatusIcon from '../statusIcon/StatusIcon.mjs';
import Body from '../body/Body.mjs';

const iconTypes = new Set([Sentiment.NEGATIVE, Sentiment.ERROR, Sentiment.POSITIVE, Sentiment.SUCCESS, Sentiment.WARNING]);
/**
 * Avoid using `<InlineAlert>` component directly
 * it's for edge cases when `<Field />` isn't suitable for some reasons.
 *
 * Example:
 * ```
 * <Field sentiment={..} message={..}>..</Field>
 * ```
 */
function InlineAlert({
  id,
  type = 'neutral',
  iconLabel,
  className,
  children
}) {
  return /*#__PURE__*/jsxs(Body, {
    role: "alert",
    id: id,
    className: clsx('alert alert-detach', `alert-${type === Sentiment.NEGATIVE || type === Sentiment.ERROR ? 'danger' : type}`, 'd-flex', className),
    children: [iconTypes.has(type) && /*#__PURE__*/jsx(StatusIcon, {
      sentiment: type,
      size: Size.SMALL,
      iconLabel: iconLabel
    }), /*#__PURE__*/jsx("div", {
      children: children
    })]
  });
}

export { InlineAlert as default };
//# sourceMappingURL=InlineAlert.mjs.map
